import getLangLocale from 'I18n/utils/getLangLocale';
import { useQuery } from 'data-fetching-client';
import { GET_TRANSLATED_PRIORITY_FEATURES_QUERY } from '../../../../../__generated__/chirp/com/hubspot/feature/store/rpc/PriorityFeaturesRpc.dfc.new';
const usePriorityFeaturesForApiName = ({
  productApiName
}) => {
  const {
    data,
    loading
  } = useQuery(GET_TRANSLATED_PRIORITY_FEATURES_QUERY, {
    variables: {
      productApiName,
      i18nLangLocale: getLangLocale()
    }
  });
  return {
    priorityFeatures: (data === null || data === void 0 ? void 0 : data.result.priorityFeatures) || [],
    loading
  };
};
const usePriorityFeaturesForApiNameHideFromLang = ({
  productApiName
}) => {
  const {
    priorityFeatures,
    loading
  } = usePriorityFeaturesForApiName({
    productApiName
  });
  return {
    priorityFeatures: priorityFeatures.filter(feature => !feature.hideFromLang),
    loading
  };
};
export const useCategorizedPriorityFeatures = ({
  productApiName
}) => {
  const {
    loading,
    priorityFeatures: features
  } = usePriorityFeaturesForApiNameHideFromLang({
    productApiName
  });
  const brandingAndLimitFeatures = features.filter(feature => feature.featureType === 'LIMIT_INCREASE' || feature.featureType === 'REMOVE_BRANDING');
  const uncategorizedFeatures = features.filter(feature => !feature.featureType);
  return {
    loading,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  };
};